import "./App.css";
import React, { Suspense, lazy, memo } from "react";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import ScrollToTop from "./components/ScrollToTop";

// Eagerly load HomePage for fast initial render (LCP optimization)
import HomePage from "./pages/HomePage";

// Lazy load all other pages for code splitting
const ProjectsPage = lazy(() => import("./pages/ProjectsPage"));
const ContactPage = lazy(() => import("./pages/ContactPage"));
const SeashellRasElHekmaPage = lazy(() => import("./pages/SeashellRasElHekmaPage"));
const SeashellPage = lazy(() => import("./pages/SeashellPage"));
const PlayaGhazalaPage = lazy(() => import("./pages/PlayaGhazalaPage"));
const PlayaRasElHekmaPage = lazy(() => import("./pages/PlayaRasElHekmaPage"));
const NewkairoPage = lazy(() => import("./pages/NewkairoPage"));
const NewgizaPage = lazy(() => import("./pages/NewgizaPage"));
const IvyPage = lazy(() => import("./pages/IvyPage"));
const HaciendaRedPage = lazy(() => import("./pages/HaciendaRedPage"));
const TheCollectionPage = lazy(() => import("./pages/TheCollectionPage"));
const ArtlifePage = lazy(() => import("./pages/ArtlifePage"));
const TwilightResidencesPage = lazy(() => import("./pages/TwilightResidencesPage"));
const EinBayPage = lazy(() => import("./pages/EinBayPage"));
const AboutPage = lazy(() => import("./pages/AboutPage"));
const ArticlesPage = lazy(() => import("./pages/ArticlesPage"));
const ArticlePage = lazy(() => import("./pages/ArticlePage"));
const HomePageAr = lazy(() => import("./pages/ar/HomePageAr"));

// Ultra-lightweight loading fallback - GPU accelerated
const PageLoader = memo(() => (
  <div className="min-h-screen flex items-center justify-center bg-white">
    <div 
      className="w-8 h-8 border-2 border-stone-200 border-t-stone-600 rounded-full"
      style={{
        animation: 'spin 0.6s linear infinite',
        transform: 'translateZ(0)' // GPU acceleration
      }}
    />
    <style>{`
      @keyframes spin {
        to { transform: translateZ(0) rotate(360deg); }
      }
    `}</style>
  </div>
));

function App() {
  return (
    <HelmetProvider>
      <div className="App">
        <BrowserRouter>
          <ScrollToTop />
          <Suspense fallback={<PageLoader />}>
            <Routes>
              <Route path="/" element={<HomePage />} />
              <Route path="/projects" element={<ProjectsPage />} />
              <Route path="/seashell" element={<SeashellPage />} />
              <Route path="/projects/seashell" element={<SeashellPage />} />
              <Route path="/projects/seashell-ras-el-hekma" element={<SeashellRasElHekmaPage />} />
              <Route path="/projects/playa-ghazala" element={<PlayaGhazalaPage />} />
              <Route path="/projects/playa-ras-el-hekma" element={<PlayaRasElHekmaPage />} />
              <Route path="/projects/newkairo" element={<NewkairoPage />} />
              <Route path="/projects/newgiza" element={<NewgizaPage />} />
              <Route path="/ivy" element={<IvyPage />} />
              <Route path="/projects/ivy" element={<IvyPage />} />
              <Route path="/hacienda-red" element={<HaciendaRedPage />} />
              <Route path="/projects/hacienda-red" element={<HaciendaRedPage />} />
              <Route path="/the-collection" element={<TheCollectionPage />} />
              <Route path="/projects/the-collection" element={<TheCollectionPage />} />
              <Route path="/artlife" element={<ArtlifePage />} />
              <Route path="/projects/artlife" element={<ArtlifePage />} />
              <Route path="/twilight-residences" element={<TwilightResidencesPage />} />
              <Route path="/projects/twilight-residences" element={<TwilightResidencesPage />} />
              <Route path="/ein-bay" element={<EinBayPage />} />
              <Route path="/projects/ein-bay" element={<EinBayPage />} />
              <Route path="/about" element={<AboutPage />} />
              <Route path="/about-us" element={<AboutPage />} />
              <Route path="/contact" element={<ContactPage />} />
              <Route path="/articles" element={<ArticlesPage />} />
              <Route path="/articles/:slug" element={<ArticlePage />} />
              <Route path="/ar" element={<HomePageAr />} />
              <Route path="/ar/" element={<HomePageAr />} />
            </Routes>
          </Suspense>
        </BrowserRouter>
      </div>
    </HelmetProvider>
  );
}

export default App;
